import {
  SHOW_MODAL_GHI_CHU_CHO_VAY,
  POST_GHI_CHU_CHO_VAY,
  POST_GHI_CHU_CHO_VAY_SUCCESS,
  POST_GHI_CHU_CHO_VAY_FAILURE,
  DELETE_GHI_CHU_CHO_VAY,
  DELETE_GHI_CHU_CHO_VAY_SUCCESS,
  DELETE_GHI_CHU_CHO_VAY_FAILURE,
  SET_LOAD_GHI_CHU_CHO_VAY,
} from "actions/GhiChuChoVay/actionTypes";

const initialState = {
  showGhiChuChoVay: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  loadGhiChu: false,
};

const showModalGhiChuChoVay = (state, action) => {
  return {
    ...state,
    showGhiChuChoVay: !state.showGhiChuChoVay,
  };
};

const postGhiChuChoVay = (state, action) => ({
  ...state,
  postGhiChuChoVay: true,
});

const postGhiChuChoVaySuccess = (state, action) => {
  return {
    ...state,
    postGhiChuChoVay: false,
    objList: action.payload,
  };
};

const postGhiChuChoVayFailed = (state, action) => ({
  ...state,
  postGhiChuChoVay: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const deleteGhiChuChoVay = (state, action) => ({
  ...state,
  deleteGhiChuChoVay: true,
});

const deleteGhiChuChoVaySuccess = (state, action) => {
  return {
    ...state,
    deleteGhiChuChoVay: false,
  };
};

const deleteGhiChuChoVayFailed = (state, action) => ({
  ...state,
  deleteGhiChuChoVay: false,
});
const setLoadGhiChuChoVay = (state, action) => {
  return {
    ...state,
    loadGhiChu: !state.loadGhiChu,
  };
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL_GHI_CHU_CHO_VAY:
      return showModalGhiChuChoVay(state, action);
    case POST_GHI_CHU_CHO_VAY:
      return postGhiChuChoVay(state, action);
    case POST_GHI_CHU_CHO_VAY_SUCCESS:
      return postGhiChuChoVaySuccess(state, action);
    case POST_GHI_CHU_CHO_VAY_FAILURE:
      return postGhiChuChoVayFailed(state, action);
    case DELETE_GHI_CHU_CHO_VAY:
      return deleteGhiChuChoVay(state, action);
    case DELETE_GHI_CHU_CHO_VAY_SUCCESS:
      return deleteGhiChuChoVaySuccess(state, action);
    case SET_LOAD_GHI_CHU_CHO_VAY:
      return setLoadGhiChuChoVay(state, action);
    case DELETE_GHI_CHU_CHO_VAY_FAILURE:
      return deleteGhiChuChoVayFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
